import React, {Component} from 'react';
import Loading from "../../../Containers/Loading";
import * as AttendanceService from "../../../../services/Attendance/AttendanceService";

class MobileNumber extends Component {

    state = {
        isLoadingHide: false,
        inputValue: ''
    }

    componentDidMount = () => {
        this.setState({
            isLoadingHide: true
        });
    }

    onInputValueChanged = (e) => {
        this.setState({
            inputValue: e.target.value
        })
    };

    inputValidation = () => {
        this.requestCallNum = null;
        if (this.state.inputValue == null || (this.state.inputValue.trim() === '')) {
            alert('전화번호를 입력해 주세요.');
            return false;
        } else {
            const regexType = /^([0-9]{11})$/;
            if (!regexType.test(this.state.inputValue)) {
                alert('올바른 전화번호를 입력해 주세요.');
                return false;
            }
        }
        return true;
    }

    onSignIn = () => {
        if (!this.inputValidation()) {
            return false;
        }

        AttendanceService.signIn(this.state.inputValue).then((response) => {
            if (response.status === 200) {
                let responseData = response.data;
                alert(responseData.data);
                if (responseData.code === '0000') {
                    this.setState({
                        inputValue: ''
                    })
                }
            } else {
                alert('SIGN IN ERROR');
            }
        }).catch((error) => {
            console.log(error);
            alert("SERVER ERROR");
        });
    }

    onSignOut = () => {
        if (!this.inputValidation()) {
            return false;
        }

        AttendanceService.signOut(this.state.inputValue).then((response) => {
            if (response.status === 200) {
                let responseData = response.data;
                alert(responseData.data);
                if (responseData.code === '0000') {
                    this.setState({
                        inputValue: ''
                    })
                }
            } else {
                alert('SIGN OUT ERROR');
            }
        }).catch((error) => {
            console.log(error);
            alert("SERVER ERROR");
        });
    }

    render() {
        if (!this.state.isLoadingHide) {
            return (<Loading/>);
        }

        return (
            <div className="allconWrapper">
                <div className="contentsWrapper">
                    <div className="pageContents">
                        <div className="loginBox">
                            <fieldset>
                                <legend className="screenOut">학생 등원/하원</legend>
                                <h3>
                                    <img src="/images/common/logo_beacon_big.png" alt="Beacon Education"></img>
                                </h3>
                                <div className="formContents">
                                    <div className="inputWrapper">
                        <span className="customInputBox">
                          <label htmlFor="requestCallNum">
                            <span>폰 번호</span>
                            <input type="text" value={this.state.inputValue} placeholder="숫자만 입력"
                                   onChange={this.onInputValueChanged}/>
                          </label>
                        </span>
                                    </div>
                                    <div className="btnWrapper">
                                        <a title="" className="baseBtn  loginYellow"
                                           onClick={() => this.onSignIn()}><span>등원</span></a>
                                        <a title="" className="baseBtn  loginOrange"
                                           onClick={() => this.onSignOut()}><span>하원</span></a>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default MobileNumber;


// WEBPACK FOOTER //
// ./src/components/Pages/Attendance/AttendanceMain/MobileNumber.js